<template>
    <!--====== Hero Section Start ======-->

    <section id="home" class="slider-area fix p-relative py-50 pt-160">
        <swiper :slides-per-view="1"
                :space-between="0"
                :modules="modules"
                :navigation="true"
                :pagination="{ clickable: true }"
                :autoplay="{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }"
                :allow-touch-move="true"
                loop=true>
            <swiper-slide>
                <div class="single-slider slider-bg d-flex align-items-center ">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-5 col-md-11">
                                <div class="hero-content-three rpt-15 rmb-75">
                                    <h1 class="mb-15 wow fadeInUp delay-0-2s">
                                        Reach new customers, get booked, and get paid - anytime, anywhere
                                    </h1>
                                    <p class="wow fadeInUp delay-0-4s">
                                        <b>Kotina gives local businesses the tools to thrive online - starting with a free, ready-to-use website.</b><br />
                                        From street food vendors to tour guides, spas to water sports, we make it easy for you to get discovered, get booked, and
                                        grow - all in just a few clicks.

                                    </p>
                                    <div class="hero-btns mt-40 wow fadeInUp delay-0-8s">
                                        <!--<a href="contact.html" class="theme-btn mb-15">Get Free Trial <i class="fas fa-arrow-right"></i></a>-->
                                        <router-link to="/contactus" class="theme-btn mb-15">
                                            Get Free Trial <i class="fas fa-arrow-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7">
                                <div class="hero-image-three overlay wow fadeInLeft delay-0-4s">
                                    <img src="../assets/images/hero/hero-image.png" alt="Hero" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="single-slider slider-bg d-flex align-items-center ">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-5 col-md-11">
                                <div class="hero-content-three rpt-15 rmb-75">
                                    <h1 class="mb-15 wow fadeInUp delay-0-2s">
                                        Bringing More Customers to Your Doorstep
                                    </h1>
                                    <p class="wow fadeInUp delay-0-4s">
                                        <b>Through the power of online booking.</b><br />
                                        Own a shack that sells food, rents kayaks, and gives massages? Do it all in Kotina. Unified tools to manage assets, staff, and customer communication.
                                    </p>
                                    <div class="hero-btns mt-40 wow fadeInUp delay-0-8s">
                                        <!--<a href="contact.html" class="theme-btn mb-15">Get Free Trial <i class="fas fa-arrow-right"></i></a>-->
                                        <router-link to="/contactus" class="theme-btn mb-15">
                                            Get Free Trial <i class="fas fa-arrow-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7">
                                <div class="hero-image-three overlay wow fadeInLeft delay-0-4s">
                                    <img src="../assets/images/hero-image2.png" alt="Hero" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </section>
    <!--====== Hero Section End ======-->
    <!--====== Feature Section Start ======-->
    <section class="feedback-section-three bg-blue rel z-1 py-115 rpy-85" style="">
        <div class="container">
            <div class="row">
                <div class="col-xl-4">
                    <div class="feedback-three-content mt-15 text-white wow fadeInUp delay-0-2s">
                        <div class="section-title mb-25">
                            <span class="sub-title">Features</span>
                            <h2>What You Can Manage With Kotina</h2>
                        </div>
                        <ul>
                            <li> <i class="fa fa-check pr-2"></i>Restaurants & Cafes</li>
                            <li> <i class="fa fa-check pr-2"></i>SPAs & Salons</li>
                            <li> <i class="fa fa-check pr-2"></i>Water Sports & Adventure Operators</li>
                            <li> <i class="fa fa-check pr-2"></i>Tour Companies & Travel Services</li>
                            <li> <i class="fa fa-check pr-2"></i>Street Food Vendors</li>
                            <li> <i class="fa fa-check pr-2"></i>Wine & Liquor Shops</li>
                            <li> <i class="fa fa-check pr-2"></i>Rental Businesses (e.g. Golf Carts, Jet Skis)</li>

                        </ul>
                        <div class="slider-dots-area mt-25"></div>
                    </div>
                </div>
                <div class="col-xl-8">
                    <div class="feedback-three-wrap">
                        <div class="feedback-item-two wow fadeInUp delay-0-4s">
                            <img src="../assets/images/hotel-resort.jpg" alt="Vacation Home" class="img-fluid" />
                            <h3 id="person1" aria-hidden="true">Hotels & Resorts</h3>
                            <p>Manage room bookings, guest services, staff schedules, and payments all in one place-fully integrated with concierge and housekeeping tools.</p>
                        </div>
                        <div class="feedback-item-two wow fadeInUp delay-0-6s">
                            <img src="../assets/images/rentals.jpg" alt="Yacht" class="img-fluid" />
                            <h3 id="person1" aria-hidden="true">Short/Long-Term Rentals</h3>
                            <p>Easily rent out properties, manage tenant requests, handle maintenance schedules, and track rental income with automated invoicing.</p>
                        </div>
                        <div class="feedback-item-two wow fadeInUp delay-0-8s">
                            <img src="../assets/images/spa.jpg" alt="Aircraft" class="img-fluid" />
                            <h3 id="person1" aria-hidden="true">Spas & Wellness Centers</h3>
                            <p>Allow customers to book treatments online, assign therapists, track appointments, and upsell packages or memberships effortlessly.</p>
                        </div>
                        <div class="feedback-item-two wow fadeInUp delay-1-0s">
                            <img src="../assets/images/restaurants-cafe.jpg" alt="Storage Unit" class="img-fluid" />
                            <h3 id="person1" aria-hidden="true">Restaurants & Cafes</h3>
                            <p>Enable table reservations, event bookings, menu management, and pre-orders while syncing operations with the broader property ecosystem.</p>
                        </div>
                        <div class="feedback-item-two wow fadeInUp delay-1-0s">
                            <img src="../assets/images/tour.jpg" alt="Storage Unit" class="img-fluid" />
                            <h3 id="person1" aria-hidden="true">Tours, Activities & Excursions</h3>
                            <p>List and manage guided tours, outdoor adventures, and custom experiences with real-time availability, capacity limits, and smart booking.</p>
                        </div>
                        <div class="feedback-item-two wow fadeInUp delay-1-0s">
                            <img src="../assets/images/golfcart-rental.jpg" alt="Storage Unit" class="img-fluid" />
                            <h3 id="person1" aria-hidden="true">Golf Cart & Vehicle Rentals</h3>
                            <p>Track availability, set pricing, handle reservations, and schedule pickups or drop-offs for carts, bikes, and vehicles from one interface.</p>
                        </div>
                        <div class="feedback-item-two wow fadeInUp delay-1-0s">
                            <img src="../assets/images/real-estate-sale.jpg" alt="Storage Unit" class="img-fluid" />
                            <h3 id="person1" aria-hidden="true">Real Estate Sales</h3>
                            <p>Showcase listings, manage leads, facilitate digital agreements, and track deals-from open house to offer to final signature.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="services-section rel z-3 pt-130 rpy-100 " id="service">
        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-xl-10 col-lg-10 col-md-10">
                    <div class="section-title mb-40">
                        <h2>Everything You Need to Run and Grow Your Business</h2>
                    </div>
                </div>
            </div>
            <section id="home1" class="slider-area fix p-relative py-50 pt-0">
                <swiper :slides-per-view="2"
                        :space-between="0"
                        :modules="modules"
                        :navigation="true"
                        :pagination="{ clickable: true }"
                        :autoplay="{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }"
                        :allow-touch-move="true"
                        :loop="true"
                        :breakpoints="{
                                        0: {
                                          slidesPerView: 1
                                        },
                                        768: {
                                          slidesPerView: 2
                                        }
                                      }">


                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">

                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/booking-mang.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">Centralized Booking Management</h3>
                                        <ul class="nolist">
                                            <li>Manage bookings across hotels, spas, tours, and rentals from one dashboard</li>
                                            <li>Calendar views by day, week, or month for efficient planning</li>
                                            <li>Auto-confirmations, reminders, and cancellation handling</li>
                                            <li>Supports both individual and group reservations</li>

                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">

                            <div class="row align-items-center">

                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/invoice-mang.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">Integrated Invoicing & Payments</h3>
                                        <ul class="nolist">
                                            <li>Auto-generate invoices for services, rentals, and experiences</li>
                                            <li>Support for partial, split, and recurring payments</li>
                                            <li>Integration with payment gateways for secure checkout</li>
                                            <li>Live financial tracking and exportable statements</li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">

                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/crm.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">Built-in CRM & Staff Scheduling</h3>
                                        <ul class="nolist">
                                            <li>Maintain rich customer profiles and service histories</li>
                                            <li>Schedule staff by shift, service, or asset type</li>
                                            <li>View availability, track leaves, and assign tasks visually</li>
                                            <li>Improve communication with internal notes and alerts</li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">
                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/white-lebel-opti.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">White-label Customization</h3>
                                        <ul class="nolist">
                                            <li>Brand your platform with custom logos, domains, and colors</li>
                                            <li>Personalized email templates and automated notifications</li>
                                            <li>Flexible page layouts and booking flows</li>
                                            <li>Perfect for franchises and regional resellers</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">

                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/concierge.png" alt="concierge" class="img-fluid">
                                        <h3 class="newmar">Concierge Service Management</h3>
                                        <ul class="nolist">
                                            <li>Offer additional services like transfers, spa treatments, or event planning</li>
                                            <li>Guests submit requests directly from the customer portal</li>
                                            <li>Assign tasks to staff or third-party vendors</li>
                                            <li>Track delivery status and upsell performance</li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">

                            <div class="row align-items-center">

                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/asset-swapping.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">Asset Swapping & Vacation Exchange</h3>
                                        <ul class="nolist">
                                            <li>Enable secure time or service swaps (e.g., spa for car rental)</li>
                                            <li>Intelligent matching engine ensures fair value</li>
                                            <li>Escrow-like system for trust and transparency</li>
                                            <li>Ideal for fractional ownership, loyalty programs, or seasonal sharing</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">
                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/e-sign.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">E-Signatures for Documents</h3>
                                        <ul class="nolist">
                                            <li>Sign rental, service, or sales contracts digitally</li>
                                            <li>Works across devices, securely and compliantly</li>
                                            <li>Includes audit logs and time stamps</li>
                                            <li>Speeds up closing processes</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">
                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/housekeeping.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">Housekeeping Management</h3>
                                        <ul class="nolist">
                                            <li>Schedule cleanings based on check-in/check-out calendars</li>
                                            <li>Track room status: dirty, in-progress, cleaned</li>
                                            <li>Assign tasks to housekeeping staff and monitor completion</li>
                                            <li>Sync with booking data for automated turnover planning</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">
                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/notifications.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">Notifications & Confirmations</h3>
                                        <ul class="nolist">
                                            <li>Stay informed with instant notifications and confirmations</li>
                                            <li>Receive automatic booking confirmations and timely reminders</li>
                                            <li>Keep your customers updated with seamless digital communications</li>
                                            <li>Ensure smooth operations with clear and consistent notifications</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <!--<swiper-slide>
                        <div class="single-slider slider-bg d-flex align-items-center ">
                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="everythingyouneed">
                                        <img src="../assets/images/housekeeping.png" alt="CRM" class="img-fluid">
                                        <h3 class="newmar">Mobile-Friendly Design</h3>
                                        <ul class="nolist">
                                            <li>Schedule cleanings based on check-in/check-out calendars</li>
                                            <li>Track room status: dirty, in-progress, cleaned</li>
                                            <li>Assign tasks to housekeeping staff and monitor completion</li>
                                            <li>Sync with booking data for automated turnover planning</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>-->

                </swiper>
            </section>            
        </div>
        <div class="dots-circle-half">
            <img src="../assets/images/shapes/dots-circle-half.png" alt="shape">
        </div>
    </section>
    <section class="dashboard-section rel z-1 pt-100 rpy-100 newbg mobile-padding-bottom0">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xl-10 mx-auto">
                    <div class="row align-items-center">
                        <div class="col-xl-6 col-lg-6 justify-content-center text-center order-lg-1">
                            <img src="../assets/images/market-place.png" alt="Dashboard Screenshot">
                        </div>
                        <div class="col-xl-6 col-lg-6 order-lg-2">
                            <div class="browswr-support-content " style="visibility: visible; ">
                                <div class="section-title">
                                    <h2 class="newpadding">
                                        The Marketplace Advantage
                                    </h2>
                                    <p>Kotina is not just software it is a marketplace. Businesses gain visibility, consumers gain convenience, and everyone wins.</p>
                                    <ul class="nolist">
                                        <li>Central storefront for consumer discovery</li>
                                        <li>Filters to explore experiences & accommodations</li>
                                        <li>Secure transactions with escrow, validation & fraud control</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="dashboard-section rel z-1 rpy-100 newbg pb-100 pt-100 mobile-padding-bottom0">

        <div class="container overflow-hidden">
            <div class="row gy-4 gy-xl-0 mb-4">
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/Free-Website.png" />
                            <h4 class="mb-4">Free Website</h4>
                            <p class="mb-4 text-secondary">
                                No setup fees. No monthly subscription.
                            </p>

                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/Instant-Activation.png" />
                            <h4 class="mb-4">Instant Activation</h4>
                            <p class="mb-4 text-secondary">
                                Your fully functional website is ready in minutes-accept bookings and orders immediately.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/Professional-Template.png" />
                            <h4 class="mb-4">100+ Professional Templates</h4>
                            <p class="mb-4 text-secondary">
                                Choose from a wide range of beautifully designed website templates tailored to your industry.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/Direct-Pay.png" />
                            <h4 class="mb-4">Direct Pay</h4>
                            <p class="mb-4 text-secondary">
                                All payments go straight to your account. No middlemen, no commission cuts.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/24-7Website.png" />
                            <h4 class="mb-4">24/7 Website</h4>
                            <p class="mb-4 text-secondary">
                                Your website works round-the-clock-even while you're away-taking bookings and generating revenue.
                            </p>

                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/Marketing-&-Promotion.png" />
                            <h4 class="mb-4">Marketing & Promotion</h4>
                            <p class="mb-4 text-secondary">
                                We help promote your online business and bring you more customers.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/Personal-Onboarding-Support.png" />
                            <h4 class="mb-4">Personal Onboarding Support</h4>
                            <p class="mb-4 text-secondary">
                                A guided setup experience with our team ensures your website is ready fast, the right way.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-sm-12 col-xl-3">
                    <div class="card border-0 border-bottom border-primary shadow-sm market-place">
                        <div class="card-body text-center p-4 p-xxl-5">
                            <img style="width:70px;" src="../assets/images/Concierge-Services.png" />
                            <h4 class="mb-4">Integrated Concierge Services</h4>
                            <p class="mb-4 text-secondary">
                                Offer concierge services to renters, boosting satisfaction and revenue.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        
       
                
            
     </div>

    </section>
    <section class="dashboard-section rel z-1 py-100 rpy-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xl-10 mx-auto">
                    <div class="row align-items-center">
                        <div class="col-xl-6 col-lg-6 justify-content-center text-center">
                            <div class="dashboard-screenshot-wrap">
                                <div class="dashboard-screenshot-item">
                                    <img src="../assets/images/mobile1.png" alt="Dashboard Screenshot">
                                </div>
                                <div class="dashboard-screenshot-item">
                                    <img src="../assets/images/mobile2.png" alt="Dashboard Screenshot">
                                </div>
                                <div class="dashboard-screenshot-item">
                                    <img src="../assets/images/mobile0.png" alt="Dashboard Screenshot">
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 left-padding">
                            <div class="browswr-support-content rmb-55 wow fadeInRight delay-0-2s" style="visibility: visible; animation-name: fadeInRight;">
                                <div class="section-title">
                                    <span class="sub-title">Anytime, Anywhere</span>
                                    <h2>
                                        Kotina Mobile App To Manage Everything, Anytime, Anywhere
                                    </h2>
                                    <a href="#" class="theme-btn mt-3">Get Started <i class="fas fa-arrow-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--====== Contact Section Start ======-->
    <section class="contact-section-two bg-lighter  rel z-1 pt-115 rpt-85 pb-130 rpb-55">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="contact-left-map h-100 pr-xl-5 rpb-20 wow fadeInLeft delay-0-2s">
                        <img src="../assets/images/happy-family.jpg" class="rounded" />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="row justify-content-center text-center">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="section-title mb-50">
                                <h2>Let's get started!</h2>
                                <p>Talk with an expert and see Kotina in action.</p>
                            </div>
                        </div>
                    </div>
                    <Form id="contact-form-two" autocomplete="off" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }" class="contact-form-two">
                        <div class="getStartedbx-Frm row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <Field type="text" name="firstname" v-model="firstname"
                                           :class="{ 'form-control' : true ,'is-invalid': errors.firstname }"
                                           maxlength="50" placeholder="First Name*" />
                                    <div class="invalid-feedback">{{errors.firstname}}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <Field type="text" name="lastname" v-model="lastname"
                                           :class="{ 'form-control' : true ,'is-invalid': errors.lastname }"
                                           maxlength="50" placeholder="Last Name*" />
                                    <div class="invalid-feedback">{{errors.lastname}}</div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <Field type="text" name="email" v-model="contactusData.email"
                                           :class="{ 'form-control' : true ,'is-invalid': errors.email }"
                                           maxlength="50" placeholder="Work Email*" />
                                    <div class="invalid-feedback">{{errors.email}}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <Field v-slot="{field }"
                                           v-model="contactusData.phone"
                                           name="phone"
                                           value="value">

                                        <input-mask name="phone"
                                                    v-model="contactusData.phone"
                                                    :model-value="field.value"
                                                    mask="(999) 999-9999"
                                                    :class="{ 'form-control' : true ,'is-invalid': errors.phone }"
                                                    placeholder="(___) ___-____"
                                                    type="text"></input-mask>
                                        <div class="invalid-feedback">{{errors.phone}}</div>
                                    </Field>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <Field type="text" name="companyname" v-model="contactusData.companyname"
                                           :class="{ 'form-control' : true ,'is-invalid': errors.companyname }"
                                           maxlength="50" placeholder="Company Name*" />
                                    <div class="invalid-feedback">{{errors.companyname}}</div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <Field name="message" v-model="contactusData.message">
                                        <textarea v-model="contactusData.message"
                                                  :class="{ 'form-control' : true ,'is-invalid': errors.message }"
                                                  placeholder="Message*" />
                                    </Field>
                                    <div class="invalid-feedback">{{errors.message}}</div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button type="submit" class="theme-btn">Get Demo</button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    </section>
    <!--====== Feedback Section Start ======-->
    <section class="feedback-section-two rel z-1 py-130 rpy-100">
        <div class="container">
            <div class="row align-items-end mb-20">
                <div class="col-xl-6 col-lg-8">
                    <div class="section-title mb-20">
                        <span class="sub-title">Hear from our Customers</span>
                        <h2>What sets Kotina as all in one solution for you</h2>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-4">
                    <div class="slider-arrow-btns text-lg-right mb-30">
                        <button class="feedback-prev"><i class="fas fa-arrow-left"></i></button>
                        <button class="feedback-next"><i class="fas fa-arrow-right"></i></button>
                    </div>
                </div>
            </div>
            <div class="feedback-active" id="testSlide">
                <div class="feedback-item-two wow fadeInUp delay-0-2s p-4" style="min-height:460px;" v-for="(testimonial,index) in testimonailList">
                    <!--<img src="../assets/images/member-1.jpg" alt="Logo" style="max-width:100px; border-radius:100%;" />-->
                    <img v-if="testimonial.imagefile !='' && testimonial.imagefile != null" :src="testimonial.imagefile" class="testimonial-img" />
                    <img v-else src="../assets/images/default.png" alt="" class="testimonial-img">
                    <p>{{$filters.TruncateStr( testimonial.description,150)}}</p>
                    <div class="feedback-author">
                        <i class="flaticon-quote-1"></i>
                        <div class="author-content">
                            <h3 class="p-0">{{testimonial.authorname}}</h3>
                            <span>{{$filters.dateFormat(testimonial.posteddate)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dots-circle-half"><img src="/img/dots-circle-half.68ba9ab2.png" alt="shape"></div>
    </section>
    <!--====== Feedback Section End ======-->
    <Loading v-model:active="isLoading">
    </Loading>
</template>

<script>

    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Form, Field } from 'vee-validate';
    import { Pagination, Navigation, Scrollbar, Autoplay } from 'swiper';
    import 'swiper/css/pagination';
    import 'swiper/css/navigation';
    import 'swiper/css/virtual';
    import service from '@/service/FrontendService.js'
    import * as Yup from 'yup';
    import InputMask from "@/views/shared/inputmask/inputmasktemplate.vue"
    import FrontendService from '../service/FrontendService';
    /* import VueSlickCarousel from 'vue-slick-carousel'*/
    // Import Swiper styles
    import 'swiper/css';

    export default {
        name: 'HomeView',
        components: {
            Form, Field, InputMask,
            Swiper,
            SwiperSlide
        },
        data() {
            const companyId = localStorage.getItem("SupcompanyId")
            const schema = Yup.object().shape({
                firstname: Yup.string().required('First name is required'),
                lastname: Yup.string().required('Last name is required'),
                phone: Yup.string().required('Phone is required'),
                companyname: Yup.string().required('Company Name is required'),
                //subject: Yup.string().required('Subject is required'),
                message: Yup.string().required('Message is required'),
                email: Yup.string().required('Email is required').email('Email is invalid').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid'),
            });
            const schemaemail = Yup.object().shape({
                email: Yup.string().required('Email is required').email('Email is invalid').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid'),
            });
            return {
                modules: [Pagination, Navigation, Scrollbar, Autoplay],
                schema,
                schemaemail,
                firstname: '',
                lastname: '',
                contactusData: {
                    id: null,
                    name: '',
                    companyname: '',
                    email: null,
                    phone: '',
                    //subject: '',
                    message: '',
                    type: '',
                    companyid: localStorage.getItem("SupcompanyId"),
                    pageUrl: window.location.href,
                },

                testimonailList: [],
                emailvalue: null,
                isLoading: true,
                companyId
            }
        },
        created() {
            this.isLoading = false;
            this.getTestimonailList();
            this.SetSliderData();

        },
        updated() {
            window.scrollTo(0, 0);
        },
        methods: {
            SetSliderData() {
                if ($('.feedback-three-wrap').length) {

                    $('.feedback-three-wrap').slick({
                        dots: true,
                        infinite: true,
                        autoplay: true,
                        autoplaySpeed: 5000,
                        arrows: false,
                        appendDots: $('.slider-dots-area'),
                        centerMode: false,
                        speed: 1000,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                }
                            }
                        ]
                    });
                }
            },
            getTestimonailList() {
                this.isLoading = true;
                service.getTestimonailList().then((response) => {
                    if (this.$filters.IsNull(response.data) != null && response.data.statusCode == 200) {
                        console.log('data', response);
                        this.testimonailList = response.data.result
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                })
            },
            onSubmit() {
                debugger
                this.isLoading = true;
                this.contactusData.name = this.firstname + ' ' + this.lastname;
                this.contactusData.type = 'Request Demo';
                service.savecontactus(this.contactusData).then(res => {
                    debugger
                    this.isLoading = false;
                    if (res.data == 1) {
                        this.success('Your request has been submitted successfully. Our team will contact you soon.');
                        this.$router.push({
                            name: "thankyou",
                            state: {
                                routeMessage: {
                                    IsSuccess: true,
                                    displayMessage: 'Your request has been submitted successfully. Our team will contact you soon.'
                                }
                            }
                        });
                    }
                    else {
                        this.error('Something went wrong')
                    }
                }).catch(res => {
                    this.error("Something went wrong. Please contact site administrator.");
                    this.isLoading = false;
                })
            },
            async emailsubmit() {
                this.isLoading = true;
                var manageSubscribersModel = {
                    email: this.emailvalue
                }
                await FrontendService.AddSubscriber(manageSubscribersModel).then(Response => {
                    if (Response != null && Response.data.statusCode == 200 || Response.data.statusCode == 201) {
                        this.isLoading = false;
                        if (Response.data.statusCode == 200) {
                            this.$router.push({
                                name: "thankyou",
                                state: {
                                    routeMessage: {
                                        IsSuccess: true,
                                        displayMessage: 'You have successfully joined our subscriber list'
                                    }
                                }
                            }
                            )
                        }
                        else {
                            this.$router.push({
                                name: "thankyou",
                                state: {
                                    routeMessage: {
                                        Email: this.emailvalue,
                                        IsSuccess: false,
                                    }
                                }
                            });
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.error('Bad req')
                    }
                }).catch(res => {
                    this.error("Something went wrong. Please contact site administrator.");
                    this.isLoading = false;
                })
            }
        }
    }
</script>

<style scoped>
</style>